import { ServerResponse } from "@baseTypes/baseType";
import xhr from '@infobis/api-module'
import { ModifiedAxiosRequestConfig } from "../../store/reducers/dashboard/crops/selector";

export type ResponseTransformer<R, T> = (x: ServerResponse<R>, thunkApi: any) => Promise<ServerResponse<T>>
const identityTransformer = <R, T>(x: ServerResponse<R>) => Promise.resolve(x) as unknown as Promise<ServerResponse<T>>


export const Methods = {
    GET: 'GET',
    POST: 'POST'
} as const

export type MethodsType = typeof Methods[keyof typeof Methods]

/*
* R - Response type generic
* T - ResponseTransformer return type generic
* B - Body type generic;
* */
export const dashboardFetchReq = <R, T = R, B = {}>(transformer: ResponseTransformer<R, T> = identityTransformer, thunkApi: any) => {
    return async (config: ModifiedAxiosRequestConfig<B>) => {
        const response = await xhr.fetch<ServerResponse<R>>(config.url, {...config, signal: thunkApi.signal })
        return transformer(response, thunkApi)
    }
}